import { Flex, FlexProps } from '@chakra-ui/react';
import { PIXEL_IMAGE } from '~/constants';
import { getMainPlatformData } from '~/creatorUtils';
import { CreatorBenchmarks, CreatorType, DefaultMediaPackType } from '~/types';

import { AboutYou } from '../MediaPacksDefaultTemplate/AboutYou';
import { AverageMetrics } from '../MediaPacksDefaultTemplate/AverageMetrics';

interface Props extends FlexProps {
  mediaPack: DefaultMediaPackType;
  creator: CreatorType;
  onOpenAboutYou?: () => void;
  creatorBenchmarks: CreatorBenchmarks;
  isSharedView?: boolean;
}

export const AboutYouAndMetricsSection: React.FC<Props> = ({
  mediaPack,
  creator,
  onOpenAboutYou,
  isSharedView,
  creatorBenchmarks,
}) => {
  const platformData = creator && getMainPlatformData(creator);

  return (
    <Flex
      width="100%"
      maxWidth="1500px"
      gap={{
        base: 4,
        md: 8,
        xl: 20,
      }}
      paddingX={{
        base: 8,
        md: 20,
        xl: 48,
      }}
      direction={{
        base: 'column',
        md: 'row',
      }}
      marginX="auto"
    >
      <AboutYou
        mediaPack={mediaPack}
        avatarUrl={platformData?.avatar || PIXEL_IMAGE}
        marginTop={0}
        onEdit={onOpenAboutYou}
        isSharedView={isSharedView}
      />
      <AverageMetrics
        creatorBenchmarks={creatorBenchmarks}
        mediaPack={mediaPack}
        marginLeft={{ lg: 5, xl: 0 }}
      />
    </Flex>
  );
};
